import type { Media, Theme } from '../../types/props'

export interface TabItem {
  /** Tab 标签文本 */
  tab: string
  /** 描述文本 */
  desc: string
  /** Tab 图标 URL */
  icon: Media
  /** 视频封面图 */
  poster?: Media
  /** Tab 图标（可选） */
  tabIcon?: Media
  /** 视频 URL（可选） */
  video?: Media
}

export interface TimeIndex {
  /** 片段时长 */
  time: number
  /** 时间节点 */
  point: number
  /** 高亮索引 */
  highlightIdx: number
}

export interface TabsWithMediaProps {
  data: {
    /** 主标题 */
    title: string
    /** 默认视频封面图 */
    poster?: Media
    /** 桌面端视频 URL */
    video: Media
    /** 移动端视频 URL */
    mobvideo?: Media
    /** Tab 项列表 */
    items: TabItem[]
    /** 时间点配置（可选，用于视频时间自动切换） */
    timeIdx?: TimeIndex[]
    /** 主题，默认 light */
    theme?: Theme
  }
  /** 自定义类名 */
  className?: string
}
